/* Kimes accessibility: preserve Mageplaza behavior while exposing its controls. */
(() => {
  // Upgrade the current flat policy section headings without rewriting HTML strings or scripts.
  if (/^\/policies\/(privacy-policy|terms-of-service|refund-policy)\/?$/.test(location.pathname)) {
    const body = document.querySelector('.shopify-policy__body');
    if (body && !body.querySelector('h2')) {
      body.querySelectorAll('h3').forEach((heading) => {
        const replacement = document.createElement('h2');
        for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
        replacement.classList.add('h3');
        replacement.append(...heading.childNodes);
        heading.replaceWith(replacement);
      });
    }
  }
  const feedSelector = '.Mageplaza-MediaBlock__Container';
  const cardSelector = `${feedSelector} [class*="Post-module__wrapper"]`;
  const popupSelector = '.Mageplaza-Popup__Container-content';
  const controlSelector = '.Mageplaza_ShowMoreButton, [data-kr-feed-control]';
  let opener = null;
  let popupWasOpen = false;
  let popupAction = null;
  let loadMore = null;
  const button = (element, label) => {
    if (!element || element.matches('button, a[href]')) return;
    element.setAttribute('role', 'button');
    element.setAttribute('tabindex', '0');
    element.setAttribute('data-kr-feed-control', '');
    if (label) element.setAttribute('aria-label', label);
  };
  const enhance = () => {
    document.querySelectorAll(feedSelector).forEach((feed) => {
      const cards = [...feed.querySelectorAll('[class*="Post-module__wrapper"]')];
      cards.forEach((card, index) => button(card, `Open Instagram post ${index + 1}`));
      feed.querySelectorAll('.Mageplaza_ShowMoreButton').forEach((control) => button(control));
    });
    const popup = document.querySelector(popupSelector);
    if (popup) {
      popup.setAttribute('aria-label', 'Instagram post');
      popup.setAttribute('aria-modal', 'true');
      button(popup.querySelector('.MP-XIcon'), 'Close Instagram post');
      button(popup.querySelector('.Mageplaza-Popup__ArrowLeft'), 'Previous Instagram post');
      button(popup.querySelector('.Mageplaza-Popup__ArrowRight'), 'Next Instagram post');
      popup.querySelectorAll('[class*="caption-toggle"]').forEach((control) => button(control));
      const album = popup.querySelector('.swiper');
      const albumInstance = album?.swiper;
      popup.querySelectorAll('.Slider--prev, .Slider--next').forEach((control) => {
        button(control, control.matches('.Slider--prev') ? 'Previous image in Instagram post' : 'Next image in Instagram post');
        const boundary = control.matches('.Slider--prev') ? albumInstance?.isBeginning : albumInstance?.isEnd;
        const disabled = control.classList.contains('swiper-button-disabled') || boundary === true;
        control.setAttribute('aria-disabled', String(disabled));
        // Keep a newly disabled arrow in sequence so focus does not jump on the last image.
        control.setAttribute('tabindex', '0');
      });
      popup.querySelectorAll('.swiper-slide').forEach((slide) => {
        const siblings = [...slide.parentElement.children].filter((item) => item.matches('.swiper-slide'));
        const instance = slide.closest('.swiper')?.swiper;
        // Some vendor reopens omit active classes; retain the displayed slide via Swiper's public index.
        const activeSlide = siblings.find((item) => item.classList.contains('swiper-slide-active')) ||
          (Number.isInteger(instance?.activeIndex) && siblings[instance.activeIndex]) || siblings[0];
        const active = slide === activeSlide;
        slide.toggleAttribute('inert', !active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      if (popupAction && (document.activeElement === document.body || document.activeElement === popupAction.element) &&
        (!popupAction.element.isConnected || !popupAction.element.getClientRects().length ||
          getComputedStyle(popupAction.element).visibility === 'hidden')) {
        const candidate = popup.querySelector(popupAction.selector);
        const replacement = candidate?.getClientRects().length && getComputedStyle(candidate).visibility !== 'hidden'
          ? candidate : popup.querySelector('.MP-XIcon');
        replacement?.focus({ preventScroll: true });
        popupAction = null;
      }
      popupWasOpen = true;
    } else if (popupWasOpen) {
      popupWasOpen = false;
      popupAction = null;
      if (opener?.isConnected && document.activeElement === document.body) opener.focus({ preventScroll: true });
    }
    if (loadMore && !loadMore.control.isConnected) {
      const cards = [...loadMore.feed.querySelectorAll('[class*="Post-module__wrapper"]')];
      if (cards.length > loadMore.count) {
        if (document.activeElement === document.body) cards[loadMore.count].focus({ preventScroll: true });
        loadMore = null;
      }
    }
  };
  enhance();
  const roots = `${feedSelector}, ${popupSelector}`;
  const observer = new MutationObserver((records) => {
    const relevant = records.some((record) => record.type === 'attributes'
      ? record.target.closest?.(popupSelector) && record.target.matches('.swiper, .swiper-slide, .Slider__Button, .Mageplaza-Popup__Arrow')
      : record.target.closest?.(roots) ||
      [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === Node.ELEMENT_NODE &&
        (node.matches(roots) || node.querySelector(roots))));
    if (relevant) enhance();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  document.addEventListener('click', (event) => {
    const popup = event.target.closest?.(popupSelector);
    if (popup) {
      const selector = ['.Mageplaza-Popup__ArrowLeft', '.Mageplaza-Popup__ArrowRight', '.Slider--prev', '.Slider--next']
        .find((value) => event.target.closest?.(value));
      const control = selector && event.target.closest(selector);
      if (control?.getAttribute('aria-disabled') === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      if (control && control === document.activeElement) popupAction = { element: control, selector };
    }
    const card = event.target.closest?.(cardSelector);
    if (card) opener = card;
    const control = event.target.closest?.('.Mageplaza_ShowMoreButton');
    const feed = control?.closest(feedSelector);
    if (feed) loadMore = { control, feed, count: feed.querySelectorAll('[class*="Post-module__wrapper"]').length };
  }, true);
  document.addEventListener('keydown', (event) => {
    const popup = document.querySelector(popupSelector);
    if (event.key === 'Tab' && popup?.contains(event.target)) {
      const focusable = [...popup.querySelectorAll('a[href], button, input, select, textarea, iframe, video[controls], audio[controls], [tabindex]')]
        .filter((element) => element.tabIndex >= 0 && !element.matches(':disabled') &&
          !element.closest('[inert], [aria-hidden="true"]') && element.getClientRects().length &&
          getComputedStyle(element).visibility !== 'hidden')
        .sort((a, b) => (a.tabIndex || Infinity) - (b.tabIndex || Infinity));
      if (focusable.length) {
        // Own the complete Tab sequence so the vendor trap cannot skip our added controls.
        const current = focusable.indexOf(document.activeElement);
        const next = current < 0 ? (event.shiftKey ? focusable.length - 1 : 0)
          : (current + (event.shiftKey ? -1 : 1) + focusable.length) % focusable.length;
        event.preventDefault();
        event.stopImmediatePropagation();
        focusable[next].focus();
        return;
      }
    }
    const control = event.target.closest?.(controlSelector);
    if (!control || control.matches('button, a[href]') || !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    if (!event.repeat && control.getAttribute('aria-disabled') !== 'true') control.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  }, true);
})();
